import React from 'react';

const LogMissionEntry = ({ mission }) => {
    return (
        <div className="bg-white border border-gray-200 rounded-2xl p-4 mb-3 last:mb-0 shadow-sm">
            <h4 className="text-base font-bold text-gray-900 mb-2">Mission ID: {mission.missionId || mission.id}</h4>
            <div className="space-y-1">
                <p className="text-sm text-gray-600 font-medium tracking-tight">POI Visible: {mission.valid || mission.poiVisible}</p>
                <p className="text-sm text-gray-600 font-medium tracking-tight">POI Not Visible: {mission.invalid || mission.poiNotVisible}</p>
                <p className="text-sm text-gray-600 font-medium tracking-tight">POI Added: {mission.created || mission.poiAdded}</p>
            </div>

            {/* Status Badge */}
            <div className="mt-3">
                <span className="inline-block bg-gray-200 text-gray-600 text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                    {mission.status || 'Saved'}
                </span>
            </div>
        </div>
    );
};

export default LogMissionEntry;
